import type { Meta, StoryObj } from "@storybook/react";
import { add } from "date-fns";

import { fakeScheduleEventCardProps } from "@/__mocks__/schedule";
import type { ScheduleEventCardProps } from "@/ui/components/schedule/ScheduleEventCard";
import ScheduleEventCard from "@/ui/components/schedule/ScheduleEventCard";

const mockScheduleEvent = fakeScheduleEventCardProps();

const StoryMeta: Meta<ScheduleEventCardProps> = {
  title: "Components/Schedule/Schedule Event Card",
  component: ScheduleEventCard,
  argTypes: {},
};

type Story = StoryObj<ScheduleEventCardProps>;

const GroupClassEvent: Story = {
  args: {
    ...mockScheduleEvent,
  },
};

const NonRecurring: Story = {
  args: {
    ...mockScheduleEvent,
    isRecurring: false,
  },
};

const WithinFifteenMinutes: Story = {
  args: {
    ...mockScheduleEvent,
    // 10 minutes from now
    startDate: add(new Date(), { minutes: 10 }).toISOString(),
  },
};

const AppointmentEvent: Story = {
  args: {
    ...mockScheduleEvent,
    isGroupClassEvent: false,
  },
};

const MultipleAttendees: Story = {
  args: {
    ...mockScheduleEvent,
    attendees: [
      {
        userId: "pat-001",
        userName: "Jane Smith",
        userType: "provider",
      },
      {
        userId: "pat-002",
        userName: "John Doe",
        userType: "patient",
      },
    ],
  },
};

export {
  AppointmentEvent,
  GroupClassEvent,
  MultipleAttendees,
  NonRecurring,
  WithinFifteenMinutes,
};
export default StoryMeta;
